import React from 'react';
import CustomizableDashboard from '../../../components/dashboard/CustomizableDashboard';
import { WIDGET_CATEGORIES } from '../../../components/dashboard/widgetRegistry';

const AIOperationsDashboardPage: React.FC = () => {
  return (
    <CustomizableDashboard
      title="Overview"
      description="Monitor your AI operations — LLM performance, agent runs, costs, and safety"
      storageKey="ai-operations-dashboard-layout"
      context="ai-operations"
      widgetCategory={WIDGET_CATEGORIES.AI_OPERATIONS}
      useBackendPersistence={true}
      allowSetDefault={true}
    />
  );
};

export default AIOperationsDashboardPage;
